import { Users, X, Heart, Calendar, Shield } from "lucide-react";

export const ANNOUNCEMENT_COLOR_OPTIONS = [
  { label: "Red", gradient: "red-orange", iconClass: "flat-red" },
  { label: "Blue", gradient: "blue-cyan", iconClass: "flat-blue" },
  { label: "Green", gradient: "green-emerald", iconClass: "flat-green" },
  { label: "Purple", gradient: "purple-pink", iconClass: "flat-purple" }
];

export const ANNOUNCEMENTS = [
  {
    priority: null,
    icon: Users,
    title: "Our First All Staff Huddle is Coming",
    category: "UPDATE",
    color: "Red",
    gradientClass: "red-orange",
    description: "We're bringing together every person across the Hyvid business for our very first All Staff Huddle",
    dateAnnounced: "June 8, 2026",
    time: null,
    infoLabel: null,
    additionalInfo: "We're bringing together every person across the Hyvid business for our very first All Staff Huddle — a live video session with the whole team. Expect updates from leadership, a look at what's ahead, and recognition of the people doing great work. It's our moment to come together, across every time zone and every team. Details and your calendar invite are on their way soon.",
  },
  {
    priority: null,
    icon: Heart,
    title: "Welcome to HyvidOne",
    category: "MESSAGE",
    color: "Blue",
    gradientClass: "blue-cyan",
    description: "HyvidOne is now live and this is your central hub for everything",
    dateAnnounced: null,
    time: null,
    infoLabel: null,
    additionalInfo: "HyvidOne is now live and this is your central hub for everything — team updates, performance insights, support, and more. We'll be using this space to keep you informed and connected. More to come as we continue to build out the platform.",
  },
  {
    priority: null,
    icon: Calendar,
    title: "New Feature Coming Soon: Rewards & Recognition ",
    category: "UPDATE",
    color: "Green",
    gradientClass: "green-emerald",
    description: "We're putting the finishing touches on the Rewards & Recognition module, which will allow clients to nominate team members for outstanding work directly within HyvidOne. Watch this space — it launches in June!",
    dateAnnounced: "May 11, 2026",
    time: null,
    infoLabel: null,
    additionalInfo: "We're putting the finishing touches on the Rewards & Recognition module, which will allow clients to nominate team members for outstanding work directly within HyvidOne. Watch this space — it launches in June!",
  },
  {
    priority: null,
    icon: Users,
    title: "Introducing Your Global Team ",
    category: "MESSAGE",
    color: "Purple",
    gradientClass: "purple-pink",
    description: "Your Hyvid team members are based across the Philippines, India and Sri Lanka",
    dateAnnounced: "March 2, 2026",
    time: null,    
    infoLabel: null,
    additionalInfo: "Your Hyvid team members are based across the Philippines, India and Sri Lanka — hand-selected for their role and integrated with AI tools from day one. We'll be sharing team spotlights and updates here as we go.",

  },
];